export default __webpack_public_path__ + "static/media/404.f83706b2.png";